module.exports = {"id":"dp1_2l1q2","text":"Evaluating Information","instructions":"Can information found online sometimes be unreliable or misleading?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"1.2","questionType":"PickOne","random":false,"options":[{"id":"dp1_2l1q2-a1","text":"Yes","score":1.8},{"id":"dp1_2l1q2-a2","text":"Not sure","score":0},{"id":"dp1_2l1q2-a3","text":"No","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat1.2/l1q2.json
// module id = 944
// module chunks = 41